export default {
  TITLE: `Requests summary for {{name}}`,
  SUMMARY: ``,
  TIMEOFFSREQUESTS: `Time offs:`,
  ATTENDANCEREQUESTS: `Attendance:`,
  SHIFTS: `Shifts:`,
  REQUESTSBYTYPE: `{{count}} request of type {{typeName}}.`,
  REQUESTSBYTYPE_other: `{{count}} requests of type {{typeName}}.`,
  SHIFTSASSIGNEDTO: `Assigned to {{count}} shift.`,
  SHIFTSASSIGNEDTO_other: `Assigned to {{count}} shifts.`,
  NOSHIFTSASSIGNEDTO: `The user was not assigned to any shift for these dates.`,
  NOREQUESTS: `There was no requests for these dates.`
}
